
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.dispatchEvent(new Event('app-rendered'));
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4">
      <h1 className="text-6xl font-bold text-[#4F46E5] mb-4">404</h1>
      <h2 className="text-2xl md:text-3xl font-semibold text-gray-600 mb-6">
        Page Not Found
      </h2>
      <p className="text-gray-500 mb-6 text-center max-w-md">
        The page you are looking for does not exist or has been moved.
      </p>
      <button
        onClick={() => navigate('/')}
        className="py-3 px-8 bg-[#4F46E5] hover:bg-[#6366F1] text-white font-bold rounded-lg shadow-md transition-all duration-300"
      >
        Go Back Home
      </button>
    </div>
  );
};

export default NotFoundPage;
